import BaseService from "services/base";
import {
  NOTIFICATION_SELECTION,
  NOTIFICATION_QUERIES,
  NOTIFICATION_MUTATIONS,
  NOTIFICATION_RESPONSE_PATHS
} from "./constant";

class NotificationService extends BaseService {
  constructor() {
    super();
  }

  async find(params?: any, selection?: string) {
    const query = NOTIFICATION_QUERIES.GET_NOTIFICATIONS.replace(
      '{{selection}}',
      selection || NOTIFICATION_SELECTION
    );

    const res = await this.custom(
      {
        typeQL: "query",
        PATH_RESPONSE: NOTIFICATION_RESPONSE_PATHS.GET_NOTIFICATIONS,
        variables: params,
      },
      query
    );
    return res;
  }

  async markAsRead(params: { notificationId: string }) {
    const res = await this.custom(
      {
        typeQL: "mutation",
        PATH_RESPONSE: NOTIFICATION_RESPONSE_PATHS.MARK_AS_READ,
        variables: {
          input: {
            notificationId: params.notificationId
          }
        },
      },
      NOTIFICATION_MUTATIONS.MARK_AS_READ
    );
    return res;
  }

  async markAllAsRead() {
    const res = await this.custom(
      {
        typeQL: "mutation",
        PATH_RESPONSE: NOTIFICATION_RESPONSE_PATHS.MARK_ALL_AS_READ,
        variables: {},
      },
      NOTIFICATION_MUTATIONS.MARK_ALL_AS_READ
    );
    return res;
  }
}

export default new NotificationService();